import React, { useState } from "react";
import {
  Image,
  Platform,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  BackHandler,
} from "react-native";

import { StackActions } from "@react-navigation/native";
import Background from "../components/BackgroundAdmin";
import Title from "../components/Title";
import Logo from "../components/Logo";
import Calendario from "../components/Calendario";
import ButtonLayout from "../components/ButtonLayout";
import ButtonLayoutMenu from "../components/ButtonLayoutMenu";
import makeRequest from "../components/makeRequest";

const solapa = (startDate, endDate, periodos) => {
  periodo = { inicio: startDate, final: endDate };
  const solapados = periodos.filter((periodoAnterior) => {
    if (
      Math.min(new Date(periodoAnterior.final), new Date(periodo.final)) >
      Math.max(new Date(periodoAnterior.inicio), new Date(periodo.inicio))
    )
      return true;
    return false;
  });
  return solapados.length > 0;
};

export default function (props) {
  const [failed, setFailed] = useState(false);
  const [periodo, setPeriodo] = useState("");
  const addPeriodo = () => {
    const req = async () => {
      const method = props.route.params.delete ? "put" : "post";
      let response;
      if (method == "post") {
        response = await makeRequest("periodos", method, {
          inicio: startDate,
          final: endDate,
          instalacion_id: props.route.params.instalaciones._id,
        });
        return response[1]._id;
      }
    };
    return req();
  };
  const [startDate, setStartDate] = useState(new Date(Date.now()));
  const [endDate, setEndDate] = useState(new Date(Date.now()));

  return (
    <Background scroll={true}>
      <Logo></Logo>
      <Title style={{ fontSize: 22, fontWeight: "bold" }}>Añadir periodo</Title>
      <Title style={{ fontWeight: "bold", fontSize: 20, marginBottom: -25 }}>
        Inicio de periodo
      </Title>
      <View style={styles.calendar}>
        <Calendario onChange={setStartDate} minDate={new Date(Date.now())} />
      </View>
      <Title
        style={{
          fontWeight: "bold",
          fontSize: 20,
          marginBottom: -25,
          marginTop: 50,
        }}>
        Final de periodo
      </Title>
      <View style={styles.calendar}>
        <Calendario
          onChange={setEndDate}
          minDate={
            new Date(
              startDate.getFullYear(),
              startDate.getMonth(),
              startDate.getDate() + 1
            )
          }
        />
      </View>
      <Title style={{ fontSize: 18 }}>
        Inicio:{" "}
        <Text style={{ fontWeight: "bold" }}>
          {startDate.getDate() < 10
            ? "0" + startDate.getDate()
            : startDate.getDate()}
          /
          {startDate.getMonth() + 1 < 10
            ? "0" + (startDate.getMonth() + 1)
            : startDate.getMonth() + 1}
          /{startDate.getFullYear()}
        </Text>
      </Title>
      <Title style={{ fontSize: 18, marginBottom: 10 }}>
        Final:{" "}
        <Text style={{ fontWeight: "bold" }}>
          {endDate.getDate() < 10 ? "0" + endDate.getDate() : endDate.getDate()}
          /
          {endDate.getMonth() + 1 < 10
            ? "0" + (endDate.getMonth() + 1)
            : endDate.getMonth() + 1}
          /{endDate.getFullYear()}
        </Text>
      </Title>
      {failed && (
        <Title style={{ fontSize: 18, marginBottom: 10 }}>
          Parámetro inválidos
        </Title>
      )}
      <ButtonLayout
        text='Confirmar'
        onPress={async () => {
          const id = await addPeriodo();
          if (
            startDate < endDate &&
            !solapa(startDate, endDate, props.route.params.periodos)
          )
            id &&
              props.navigation.dispatch(
                StackActions.replace("AnadirHorarios", {
                  instalacion: props.route.params.instalaciones,
                  _id: id,
                  fechaInicio: startDate.toISOString(),
                  fechaFinal: endDate.toISOString(),
                })
              );
          else setFailed(true);
        }}
      />
      <ButtonLayoutMenu
        style={{ maxWidth: 150 }}
        text='Cancelar'
        onPress={() => props.navigation.navigate("ConfigurarHorarios")}
      />
      <View style={{ height: 50 }}></View>
    </Background>
  );
}
const styles = StyleSheet.create({
  calendar: {
    marginTop: 25,
  },
});
